import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-simple-input',
  templateUrl: './simple-input.component.html',
  styleUrls: ['./simple-input.component.scss']
})
export class SimpleInputComponent {

  @Input({ required: true }) control: FormControl = new FormControl();
  @Input() width: number = 70;
  @Input() height: number = 25;
  @Input() inputType: string = 'text';
  @Output() getChanges = new EventEmitter();

  valueChanges(value: any) {

    this.getChanges.emit(value);
  }
}
